
import {PriorCourseUnit} from "./PriorCourseUnit";
import {Credit} from "./Credit";

export class CreatePrecedentRequest {

    constructor(
                public approvedBy?: string,
                public startDate?: Date,
                public endDate?: Date,
                public priorCourseUnits?: PriorCourseUnit[],
                public credits?: Credit[],
                public nextReviewDate?: Date,
                public validityPeriodStartDate?: Date,
                public validityPeriodEndDate?: Date,
                public facaultyCode?: string) {

        this.credits =  new Array<Credit>();
        this.priorCourseUnits =  new Array<PriorCourseUnit>();
    }

}






// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/CreatePrecedentRequest.ts